<script>
  import VirtualList from './VirtualList.svelte';
  import ListItem from './ListItem.svelte';
  import items from './data';

  export let shown = false
  export const show = () => { shown = !shown }
  let searchTerm = "";



  let filters = items.map(item => item.categories);
  filters = filters.flat(1)




  filters = filters.filter(function(item, pos, self) {
    return self.indexOf(item) == pos && item.length > 0;
  });

  filters = filters.sort((a, b) => a.localeCompare(b, 'es', { sensitivity: 'base' }))
  // console.log(filters);
  let start;
  let end;

  let selection = [];

  // $: filteredList = items.filter(item => item.categories.includes(selection) !== -1)

  $: filteredList = selection.length > 0 ? items.filter(item => selection.every(element => {
    console.log(element);

    return item.categories.includes(element) ;
  })   ) : items


  // $: filteredList = selection.length > 0 ? items.filter(item => item.title.toLowerCase().indexOf(searchTerm.toLowerCase()) !== -1) : items

</script>

<div class="views-exposed-form-filters"  >
  <h4 class="views-exposed-form-filters-main " on:click={show}><i class="fas fa-sliders-h"></i> Filter by category</h4>

  {#if shown}
  <div class="views-exposed-form-filters-form" style="display: block !important;" >



    {#if filters}
    <div>

      <ul class="tags-list">

        {#each filters as filter, index}
        <li>
          <div >
            <input  type="checkbox" id="cat-{filter}" name="categories[{filter}]" 	 bind:group={selection} value={filter}  class="form-checkbox">
            <label for="cat-{filter}" class="option">  {@html filter}</label>
          </div>
        </li>
        {/each}

      </ul>



    </div>
    {/if}

  </div>
  {/if}

</div>

<div class="results-container">
<VirtualList items={filteredList} bind:start bind:end let:item>
  <ListItem {...item}/>
</VirtualList>

</div>



<style>
  .results-container {
    min-height: 1600px;
    height: calc(100vh - 15em);
    clear: both;
    padding-bottom: 20px;
    margin-bottom: 40px;
  }
  .tags-list {
    list-style: none;
    display: flex;
    justify-content: flex-start;
    margin: 0 auto;
    flex-flow: wrap row;
    width: 100%;
  }
  .tags-list li {
    padding: 0 0;
    margin-left: 12px;
    margin-right: 12px;
    opacity: 0.8;
  }
  .tags-list li:hover {
    opacity: 1;
    cursor: pointer;
  }

  .tags-list li label {
    text-transform: capitalize;
  }
</style>
